'use client';

import ErrorPage from '@shared/common/components/ErrorPage/ErrorPage';
import { ERROR_PAGE_CODE } from '@shared/constants/errorCodes';

export default function Page() {
  return <ErrorPage code={ERROR_PAGE_CODE.ERROR} />;
}
